import InputWithCopyController from "./controllers/input_with_copy_controller";

application.register("input-with-copy", InputWithCopyController);
